const VERSION = '3.0.0';
export function getVersionString() {
    return VERSION;
}
